import { Link } from "react-router-dom";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { rupiah, waLink } from "@/lib/api";

export default function OrderSuccess({ order, settings }) {
  const msg = `Halo LENSA JUARA, saya sudah memesan foto.\nKode: ${order.order_code}\nAtlet: ${order.athlete_name} (BIB ${order.bib_number})\nTotal: ${rupiah(order.total)}\nMohon diverifikasi. Terima kasih.`;
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16" data-testid="order-success">
      <CheckCircle2 className="w-14 h-14 text-emerald-400" />
      <h1 className="font-display font-black uppercase italic text-4xl sm:text-5xl mt-4">Pesanan Terkirim!</h1>
      <p className="text-neutral-300 mt-3">Simpan kode pesanan Anda. Admin akan memverifikasi bukti transfer dan menghubungi Anda via WhatsApp.</p>
      <div className="mt-8 border border-[#FF5A00] bg-[#FF5A00]/10 p-6">
        <p className="text-sm uppercase text-neutral-400">Kode Pesanan</p>
        <p data-testid="success-order-code" className="font-display font-black text-5xl tracking-wider">{order.order_code}</p>
        <p className="mt-3 text-neutral-300">{order.athlete_name} · BIB {order.bib_number} · {order.event_count} mata lomba · <b>{rupiah(order.total)}</b></p>
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        {settings && (
          <a href={waLink(settings.whatsapp_number, msg)} target="_blank" rel="noreferrer" data-testid="success-wa-btn"
            className="bg-emerald-600 hover:bg-emerald-500 active:scale-95 transition-[background-color,transform] duration-150 px-6 py-3 font-display font-bold uppercase text-lg flex items-center gap-2">
            <MessageCircle className="w-5 h-5" /> Konfirmasi via WhatsApp
          </a>
        )}
        <Link to="/cek-pesanan" data-testid="success-track-link" className="border border-white/30 hover:border-white px-6 py-3 font-display font-bold uppercase text-lg transition-colors">Cek Status</Link>
      </div>
    </div>
  );
}
